import { useQuery } from "@tanstack/react-query";
import type { Environment } from "../../../types";
import type { StakeInfo, StakeInfoResponse } from "../types";
import { getApiBase } from "../../../lib/remote-config";

export const STAKE_INFO_QUERY_KEY = "wp:stake-info";

/** POSA `GET /stake/:address` — 지갑의 스테이킹 요약(총량/리워드/위임수)을 조회. */
export function useStakeInfo(
  env: Environment,
  walletAddress: string,
  enabled = true,
) {
  const isEnabled = enabled && !!walletAddress;

  const { data, ...rest } = useQuery<StakeInfoResponse>({
    queryKey: [STAKE_INFO_QUERY_KEY, env, walletAddress],
    queryFn: async ({ signal }) => {
      const baseUrl = await getApiBase("posa", env);
      const res = await fetch(`${baseUrl}/stake/${walletAddress}`, {
        cache: "no-store",
        signal,
      });
      if (!res.ok) throw new Error(`Stake info fetch failed: ${res.status}`);
      const json: StakeInfoResponse = await res.json();
      // POSA envelope: 성공 코드는 0 또는 200.
      if (json.code !== 0 && json.code !== 200) {
        throw new Error(`Stake info API error: ${json.code}`);
      }
      return json;
    },
    enabled: isEnabled,
    staleTime: 0,
  });

  const stakeInfo: StakeInfo | undefined = data?.data;

  return { stakeInfo, ...rest };
}
